import { Box, Button, Grid } from "@mui/material";
import sorrySVG from "../../assets/sorry.svg";
import { useTranslation } from "react-i18next";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { isLogin } from "../../api/authentication/AuthenticationAPI";
import { Link } from "react-router-dom";
type RequireAccessPageProps = {
  accountLevel: string;
};

export default function RequireAccessPage(props: RequireAccessPageProps) {
  const { t } = useTranslation([
    "common",
    "error",
    "plan",
    "upgrade",
    "account",
  ]);
  return (
    <Grid container marginTop={2}>
      <Grid item xs={1.5}></Grid>
      <Grid item xs={9} className="white slide-from-bottom" paddingBottom={2}>
        <h1>
          {t("common:limited_access") +
            " " +
            t("common:with") +
            " " +
            t("common:plan") +
            " " +
            t("plan:" + props.accountLevel).toUpperCase()}
        </h1>
        <h2>
          <FavoriteIcon
            color="warning"
            style={{
              width: "24px",
              height: "24px",
              marginLeft: "10px",
              marginRight: "10px",
              paddingTop: "2px",
            }}
          />
          {t("common:thanks_for_using")}
          <FavoriteIcon
            color="warning"
            style={{
              width: "24px",
              height: "24px",
              marginLeft: "10px",
              marginRight: "10px",
              paddingTop: "2px",
            }}
          />
        </h2>
        <img src={sorrySVG} style={{ maxWidth: "50vh" }} />
        <Box display={"flex"} margin={"auto"} justifyContent={"center"}>
          <Link to="/upgrade">
            <Button
              variant="contained"
              color="error"
              style={{ marginRight: "20px", width: "200px" }}
            >
              {t("upgrade:purchase_now")}
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="contained" style={{ width: "200px" }}>
              {t("account:login")}
            </Button>
          </Link>
        </Box>
      </Grid>
      <Grid item xs={1.5}></Grid>
    </Grid>
  );
}
